import { ref } from 'vue'
import Api from "../Api"
import Image from "@/services/Image"

export function useCategories() {
    const formattedCategories = ref([])
    const isLoading = ref(false)

    const formatElement = (item) => {
        let value = item["category_id"] ?? 0
        let name = item["category_name"] ?? ""
        let hasImage = item["category_image_host"] && item["category_image_name"]
        let path = item["category_str_path"]
        let level = item["category_level"]

        if (value === 0 || name === "") {
            return []
        }

        return [{
            value,
            name,
            image: hasImage ? Image.handle(item["category_image_host"], item["category_image_name"], 60, 60) : null,
            path,
            level,
        }]
    }

    const fetchCategories = async () => {
        isLoading.value = true

        try {
            // todo должна быть первоначальная загрузка а затем уже фильтрация при поиске
            const items = await Api.categories()
            formattedCategories.value = Object.values(items).flatMap(formatElement)
        } catch (error) {
            console.error("Не удалось загрузить список категорий:", error)
        } finally {
            isLoading.value = false
        }
    }

    return {
        formattedCategories,
        isLoading,
        fetchCategories
    }
}
